module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2n7r4r-99f5866e1c73a9cf31a6f583986056cd.svg";